/**
 * MyComment
 */

import MyList from './MyList';
import Config from '../../Config';

class MyComment extends MyList {

	protected isUser: boolean;

	constructor( node: any, options: any ) {
		super( node, options );

		Config.userGuid = options.userGuid || '';
		Config.gameUserUid = options.gameUserUid || '';
		Config.gameCharacterId = options.gameCharacterId || '';
		Config.gameServerId = options.gameServerId || '';

		this.isUser = ( Config.guid && ( Config.userGuid === Config.guid ) ) ?
			false : true;

		if ( Config.gameUserUid && Config.gameServerId ) {
			this.isUser = true;
		}
	}

	public get() {
		super.get( Config.myCommentArticle( this.isUser ) );
	}
}

export default MyComment;
